import { Order } from '../../models';
import { OrderActions, OrderActionTypes } from './order.actions';

export interface State {
  payload: Order;
  loading: boolean;
  error: any;
}

export const initialState: State = {
  payload: null,
  loading: false,
  error: null,
};

export function reducer(state = initialState, action: OrderActions): State {
  switch (action.type) {
    case OrderActionTypes.CREATE_ORDER:
    case OrderActionTypes.CHECK_VAT_ID_VALIDITY:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case OrderActionTypes.CREATE_ORDER_SUCCESS:
      return {
        ...state,
        payload: action.payload,
        loading: false,
      };

    case OrderActionTypes.CREATE_ORDER_FAILURE:
    case OrderActionTypes.CHECK_VAT_ID_VALIDITY_FAILURE:
      return {
        payload: null,
        loading: false,
        error: action.payload,
      };

    case OrderActionTypes.CHECK_VAT_ID_VALIDITY_SUCCESS:
      return {
        ...state,
        payload: {
          ...state.payload,
          isVatIdValid: action.payload
        },
        loading: false,
      };

    default:
      return state;
  }
}
